import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { SessionService } from 'src/app/services/storage/session.service';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { ListItem } from 'src/app/models/listItem';
import { HelperService } from 'src/app/services/helper.service';
import { Language } from 'src/app/constants/language';
import { Router } from '@angular/router';
import { TranslationService } from 'src/app/services/translation.service';
import { MemberService } from 'src/app/services/member.service';

@Component({
    selector: 'mwp-translation',
    templateUrl: './translation.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TranslationComponent implements OnInit {
    public language: Language;
    public list: ListItem[];
    public selectedLanguage: string;

    constructor(
        private sessionService: SessionService,
        public helperService: HelperService,
        private translationService: TranslationService,
        private router: Router,
        private memberService: MemberService,
    ) { }

    ngOnInit() {
        this.list = this.helperService.convertEnumToList(Language);
        this.list.forEach((l: ListItem) => {
            if (l.value == this.sessionService.session.language)
                this.selectedLanguage = l.value;
        });
    }

    public onTranslationChange(event: MatButtonToggleChange): void {
        if (event.source) {
            this.sessionService.session.language = event.source.value;
            this.sessionService.session.member.messageCenterAlerts = null;
            this.sessionService.setSession();
        }
        const currentUrl = this.router.url; // Get the current route URL
        this.router
            .navigateByUrl('/false-endpoint', { skipLocationChange: true }) // Navigate to the same route
            .then(() => {
                this.router.navigateByUrl(currentUrl); // Navigate back to the current route
            });

        if (this.sessionService.session.isLoggedIn) {
            this.translationService.savePreferedLanguage(
                this.sessionService.session.language
            ).subscribe((response: any) => {
                return
            });
        }
    }
}
